// Vuex project module actions
import { API } from '@/config';
import { FILL_LIST } from './mutations-types';

export default {

  async createGroup(context, element) {
    try {
      await API.put('project/agentsGroups/createGroup', { ...element });
    } catch (err) {
      console.log(err);
    }
  },

  async getList({ commit }, project) {
    try {
      const params = {
        project,
      };
      const { records, total } = (await API.get('project/agentsGroups/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },

  async removeGroup(context, params) {
    try {
      await API.delete('project/agentsGroups/deleteGroup', { params });
    } catch (err) {
      console.log(err);
    }
  },

  async updateGroup(context, params) {
    try {
      await API.patch('project/agentsGroups/updateGroup', { ...params });
    } catch (err) {
      console.log(err);
    }
  },

};
